import React from 'react';
import './Stories.css'; 
import Seo from '../components/Seo';
import { useI18n } from '../i18n/I18nContext';


const Stories = () => {
  const { t } = useI18n();
  return (
    <div className="container">
      <Seo
        title={t('stories.seoTitle')}
        description={t('stories.seoDescription')}
        path="/stories"
        image="/images/yichenghao.jpg"
      />

      <h1>{t('stories.brandTitle')}</h1>
      <img src="/images/yichenghao.jpg" alt={t('stories.imageAlt')} style={{ width: "300px", display: "block", margin: "0 auto 20px" }} />
      <p>{t('stories.brandBody')}</p>
      <h2>{t('stories.who')}</h2>
      <h2>{t('stories.legend')}</h2>
      <h2>{t('stories.founder')}</h2>
      <p>{t('stories.founderBody')}</p>
      <h2>{t('stories.achievements')}</h2>
        <ul>
            <li>{t('stories.achievement1')}</li>
            <li>{t('stories.achievement2')}</li>
            <li>{t('stories.achievement3')}</li>
            <li>{t('stories.achievement4')}</li>
        </ul>
      <iframe 
        className="youtube-video"
        src="https://www.youtube.com/embed/MSDDD_k4vhk" 
        title={t('stories.videoTitle')}
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen>
      </iframe>
    </div>
  );
}

export default Stories; 
